import React from 'react';
import styled from 'styled-components';
import { useTheme } from 'styled-components';

import { ReactComponent as ArrowBig } from '../../images/arrow_big.svg';

function Accordion(props: IAccordion) {
    const theme = useTheme();
    const [expanded, setExpanded] = React.useState(props.expanded || false);

    const [childrenHeight, setChildrenHeight] = React.useState(0);

    const ref = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        setChildrenHeight(ref.current?.clientHeight || 0);
    }, []);

    return (
        <AccordionTag expanded={expanded} height={childrenHeight}>
            <div
                onClick={() => {
                    setExpanded(!expanded);
                }}
            >
                <span>{props.title}</span>
                <ArrowBig stroke={theme.color.mainFont} />
            </div>
            <div>
                <div ref={ref}>{props.children}</div>
            </div>
        </AccordionTag>
    );
}

export default React.memo(Accordion);

export interface IAccordion {
    /**
     * 자식 Type
     */
    children?: React.ReactNode;

    /**
     * 제목
     */
    title: string;

    /**
     * 확장 여부
     */
    expanded?: Boolean;
}

export interface IAccordionTag extends Pick<IAccordion, 'expanded'> {
    /**
     * 아코디언 높이 (javascript 로 설정함)
     */
    height: number;
}

export const AccordionTag = styled.div<IAccordionTag>`
    /* padding: 0 30px 30px 30px; */
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.color.borderDefault};
    background: ${({ theme }) => theme.color.box};
    overflow: hidden;

    & > div {
        &:first-child {
            height: 60px;
            padding-left: 30px;
            padding-right: 30px;

            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            font-weight: 600;

            & > svg {
                transform: rotate(${({ expanded }) => (expanded ? 0 : 180)}deg);
            }
        }

        &:last-child {
            transition: height 0.15s;
            height: ${({ expanded, height }) => (expanded ? height : 0)}px;

            border-top: ${({ expanded }) => (expanded ? 1 : 0)}px solid ${({ theme }) => theme.color.borderDefault};

            & > div {
                padding: 30px;
                & > :first-child {
                    border-radius: 10px 10px 0px 0px;
                }
                & > :last-child {
                    border-radius: 0px 0px 10px 10px;
                }
            }
        }
    }
`;
